import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap-5';
import moment from 'moment';

import ManagedInput from 'components/form/managed_input';

export default class DateInputPair extends React.Component {
  static propTypes = {
    ...Form.Control.propTypes,
    label: PropTypes.string,
    maxKey: PropTypes.string,
    maxValue: PropTypes.string,
    minKey: PropTypes.string,
    minValue: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  handleMaxChange = (value) => {
    const { maxKey } = this.props;
    this.props.onChange(value, maxKey);
  };

  handleMinChange = (value) => {
    const { minKey } = this.props;
    this.props.onChange(value, minKey);
  };

  render() {
    const { label, maxValue, minValue } = this.props;
    let endDate = maxValue;
    if (endDate) endDate = moment(endDate);
    let startDate = minValue;
    if (startDate) startDate = moment(startDate);

    return (
      <Form.Group className="d-none d-md-flex form-group">
        {label && <Form.Label>{label}</Form.Label>}
        <div className="d-flex align-items-center">
          {this.renderMin(startDate, endDate)}
          <strong className="px-2 pt-2"> TO </strong>
          {this.renderMax(startDate, endDate)}
        </div>
      </Form.Group>
    );
  }

  renderMin(startDate, endDate) {
    return (
      <ManagedInput
        className="input-pair form-control"
        endDate={endDate}
        name={`min${name}`}
        placeholder="Min"
        selectsStart
        startDate={startDate}
        type="date"
        value={startDate}
        onValueChange={this.handleMinChange}
      />
    );
  }


  renderMax(startDate, endDate) {
    return (
      <ManagedInput
        className="input-pair form-control"
        endDate={endDate}
        name={`max${name}`}
        placeholder="Max"
        selectsEnd
        startDate={startDate}
        type="date"
        value={endDate}
        onValueChange={this.handleMaxChange}
      />
    );
  }
}
